export default "__VITE_ASSET__BMbSi0VR__"